import dayjs from 'dayjs';

import { Image } from '@/components/custom-ui/Image';
import { Button } from '@/components/ui/button';
import useExportExcelCustom from '@/hooks/useExportExcelCustom';

import type {
  ICompanyItemInterface,
  ICompanyList,
} from '../../api/CompanyItems.interface';

type Props = {
  items: ICompanyItemInterface[];
  startDate: Date | null;
  endDate: Date | null;
  selectedCompany: ICompanyList | null;
};

function ExcelBtn({ items, endDate, selectedCompany, startDate }: Props) {
  // headers for the excel file
  const headers: Partial<Record<keyof ICompanyItemInterface, string>> = {
    ItemID: 'itemID',
    ItemName: 'itemName',
    UnitPrice: 'unitPrice',
    InvoiceID: 'InvoiceID',
    TrDate: 'Date',
    ClientID: 'ClientID',
    ClientName: 'ClientName',
    storeID: 'storeID',
    Qty: 'Qty',
    Bonus: 'Bonus',
    type: 'Type',
  } as const;

  // ✅ Ensure function name matches type definition
  const transformData = (
    item: ICompanyItemInterface,
  ): Partial<ICompanyItemInterface> => ({
    ItemID: item.ItemID,
    ItemName: item.ItemName,
    UnitPrice: item.UnitPrice,
    InvoiceID: item.InvoiceID,
    TrDate: dayjs(new Date(item.TrDate)).format('YYYY-MM-DD'),
    ClientID: item.ClientID,
    ClientName: item.ClientName,
    storeID: item.storeID,
    Qty: item.Qty,
    Bonus: item.Bonus,
    type:
      item.type.trim() === 'بيع'
        ? 'Sale'
        : item.type.trim() === 'مرتجع عميل'
          ? 'Return_Client'
          : item.type.trim() === 'شراء'
            ? 'Purchase'
            : 'Return_Supplier',
  });

  const exportToExcel = useExportExcelCustom(items, {
    headers,
    transformData,
    filename: `تقرير اصناف الشركات ${selectedCompany?.Name} من ${dayjs(startDate).format('YYYY-MM-DD')} الى ${dayjs(endDate).format('YYYY-MM-DD')}.xlsx`,
  });

  return (
    <Button size="sm" variant="outline" onClick={exportToExcel}>
      <Image alt="excel" src="/images/svg/excel.svg" className="ml-2 h-6 w-6" />
      تصدير اكسيل
    </Button>
  );
}

export default ExcelBtn;
